import { Provider } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NG_SCROLLBAR_OPTIONS } from 'ngx-scrollbar';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { ErrorInterceptor } from "./core/helpers/error.interceptor";
import { NotificationService } from './service/notification.service';
import { HTTP_SERVICE, HttpService, USER_AUTHENTICATION_SERVICE, UserAuthService } from "./core/services";
import { COMMON_SERVICE } from "./core/services/common.interface";
import { SettingInterceptor } from "./core/helpers/setting.interceptor";
import { LoaderService } from "./core/services/loader.service";
import { SignalRNotificationService } from "./core/services/signalr.service";
import { CommonService } from "./core/services/common.service";

export const ProviderList: Provider[] = [
    Title,
    NotificationService, LoaderService,
    {
        provide: NG_SCROLLBAR_OPTIONS,
        useValue: {
            visibility: 'hover'
        },
    },
    {
        provide: HTTP_SERVICE,
        useClass: HttpService
    },
    {
        provide: USER_AUTHENTICATION_SERVICE,
        useClass: UserAuthService
    },
    {
        provide: COMMON_SERVICE,
        useClass: CommonService
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: JwtInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: SettingInterceptor,
        multi: true
    },
    {
        provide: SignalRNotificationService,
        useClass: SignalRNotificationService
    }
];
